/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Discount/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Discount({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Discount",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#E7793B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Discount.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-Z23l1Sw': alignSelf,'--mt-2-Z23l1Sw': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z23l1Sw': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z23l1Sw': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z23l1Sw': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z23l1Sw': opacity,'--w-10-Z23l1Sw': typeof width === 'number' ? `${width}px` : width,'--h-11-Z23l1Sw': typeof height === 'number' ? `${height}px` : height,'--f-12-Z23l1Sw': fill,'--a-7-Z23l1Sw': isAnimated ? animation : "none",'--sd-8-Z23l1Sw': isAnimated ? strokeDashoffset : 0,'--sd-9-Z23l1Sw': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Discount.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M17.371 13.076c0 3.398-3.077 4.924-7.386 4.924C5.677 18 2.6 16.474 2.6 13.101c0-3.693 1.846-5.564 5.539-7.435L6.83 3.23a.8.8 0 01.69-1.23h5.219a.8.8 0 01.69 1.169l-1.598 2.496c3.693 1.846 5.54 3.717 5.54 7.41zm-9.738 2l5.715-5.714a.714.714 0 00-1.01-1.01l-5.715 5.715a.714.714 0 101.01 1.01zM6.557 9.43a1.143 1.143 0 112.286 0 1.143 1.143 0 01-2.286 0zM11.128 14a1.143 1.143 0 112.286 0 1.143 1.143 0 01-2.286 0z"
 style={{'--f-12-Z23l1Sw': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}